import React from "react";
import { Box, HStack, Text } from "@chakra-ui/react";

export type KeyValueRowProps = {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
};

const KeyValueRow: React.FC<KeyValueRowProps> = ({ label, value, icon }) => {
  return (
    <HStack
      align="flex-start"
      spacing={{ base: 2, md: 3 }}
      flexWrap={{ base: "wrap", md: "nowrap" }}
    >
      <Box mt={{ base: 0, md: "2px" }} color="#6b5a5a" flexShrink={0}>
        {icon || <Box w="20px" h="20px" />}
      </Box>
      <Box minW={0}>
        <Text fontSize="11px" fontWeight="700" letterSpacing="0.08em" color="#8a7b7b" textTransform="uppercase">
          {label}
        </Text>
        <Text
          mt="2px"
          fontSize="14px"
          fontWeight="600"
          color="#2b1b1a"
          wordBreak="break-word"
          noOfLines={{ base: 2, md: undefined }}
        >
          {value}
        </Text>
      </Box>
    </HStack>
  );
};

export default KeyValueRow;
